import React, { useEffect } from "react";
import { Form, Input, InputNumber, Upload, Button, Row, Col, message, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { updateVehiclesType } from "../../../api/vehicles-type.service";
import config from '../../../config';

const EditVehicleTypeFormModal = ({ vehicleData, onClose, fetchVehicles, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly=false }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                ...vehicleData,
                picture: vehicleData.picture
                    ? [
                        {
                            uid: "-1",
                            name: vehicleData.picture.split("\\").pop(),
                            status: "done",
                            url: config.API_URL + '/' + vehicleData.picture,
                        },
                    ]
                    : [],
            });
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (key === "picture" && values.picture && values.picture.length > 0) {
                if (values.picture[0].originFileObj) {
                    formData.append(key, values.picture[0].originFileObj);
                }
            } else {
                formData.append(key, values[key]);
            }
        });

        try {
            await updateVehiclesType(vehicleData.id, formData);
            message.success("Vehicle updated successfully!");
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            message.error(error);
            console.error("Error:", error);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            message.error("You can only upload image files!");
        }
        return isImage ? false : Upload.LIST_IGNORE;
    };

    return (
        <Modal className="vt-modal" footer={null} destroyOnClose title={`${isViewOnly ? 'View' : 'Edit'} Vehicle Type`} open={isModalOpen} onOk={handleOk} onClose={handleCancel} onCancel={handleCancel}>
            <Form disabled={isViewOnly} layout="vertical" form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Car Name" name="name" rules={[{ required: true, message: "Please enter car name" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Passengers Capacity" name="passengersCapacity" rules={[{ required: true, message: "Please enter capacity" }]}>
                            <InputNumber min={1} max={100} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Luggage" name="luggage" rules={[{ required: true, message: "Please enter luggage details" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Base Price (PKR)" name="basePricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Per Minute Price (PKR)" name="perMinutePricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Per Day Price (PKR)" name="perDayPricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Available Cars" name="noOfAvbCars" rules={[{ required: true, message: "Please enter available cars" }]}>
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item rules={[{ required: true, message: "Picture is required" }]} label="Car Picture" name="picture" valuePropName="fileList" getValueFromEvent={(e) => e?.fileList || []}>
                            <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
                                <Button icon={<UploadOutlined />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row>

                {!isViewOnly && <Form.Item>
                    <Button type="primary" htmlType="submit">Update</Button>
                    <Button style={{ marginLeft: 8 }} onClick={()=>{
                        setIsModalOpen(false);
                    }}>Cancel</Button>
                </Form.Item>}
            </Form>
        </Modal>
    );
};

export default EditVehicleTypeFormModal;
